import { computed } from '@ember/object';
import { cumulativeAverageSeries } from 'cio/helpers/cio-math';

export default function computedRatioSeries(numerator, denominator) {
  return computed(numerator, denominator, function () {
    return cumulativeAverageSeries(this.get(numerator), this.get(denominator));
  });
}
